import { createFileRoute } from '@tanstack/react-router';
import { DocumentsSettingsPage } from '@/features/admin';

export const Route = createFileRoute('/_auth/o/$orgId/admin/documents')({
  component: DocumentsSettingsPage,
});
